import RfiDocumentField from './RfiDocumentField.component';

export default RfiDocumentField;
